import React, { useEffect, useState } from "react";
// import { FiAward } from "react-icons/fi";
import "react-horizontal-scrolling-menu/dist/styles.css";
// import CardDetail from "./Cards/CardDetail";
// import { reactIcons } from "../../utils/icons";
// import DashboardCard from "./Cards/DashboardCard";
// import * as api from "../../redux/api";
// import { toast } from "react-toastify";
import Spinner from "../../components/loaders/Spinner";
import { metrics } from "../../utils/constants";
import { reactIcons } from "../../utils/icons";
import { DataGrid } from "@mui/x-data-grid";
import ActionButton from "../../components/Forms/ActionButton";
import { LinearProgress, Switch } from "@mui/material";
import CustomNoRowsOverlay from "../../utils/styles";

const DashboardLanding = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowCountState, setRowCountState] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 8
  });
  // const [stages, setStages] = useState([]);
  // const [cardData, setCardData] = useState({
  //   status: false,
  //   data: ""
  // });
  // const handleClick = (item) => {
  //   if (item) {
  //     setCardData({ status: true, data: item });
  //   }
  // };
  // const getAllStages = async () => {
  //   setIsLoading(true);
  //   const res = await api.getStages();
  //   const { status, data } = res;
  //   if (status >= 200 && status < 300) {
  //     setStages(data);
  //     setIsLoading(false);
  //   } else {
  //     setIsLoading(false);
  //     toast.error(data.message);
  //   }
  // };
  useEffect(() => {
    // getAllStages();
  }, []);

  let columns = [
    {
      field: "_id",
      headerName: "S.No.",
      type: "number",
      headerAlign: "center",
      align: "center",
      width: 100
    },
    {
      field: "name",
      headerName: "Name",
      type: "string",
      flex: 2
    },
    {
      field: "email",
      headerName: "Email",
      type: "string",
      flex: 3,
      valueFormatter: (params) => (params.value ? params.value : "-")
    },
    {
      field: "mobile",
      headerName: "Mobile",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 2,
      valueFormatter: (params) => (params.value ? params.value : "-")
    },
    {
      field: "isVerified",
      headerName: "Verified",
      type: "boolean",
      flex: 2,
      renderCell: (params) => (
        <Switch
          checked={params.value}
          color="default"
          sx={{
            "& .MuiSwitch-thumb": {
              backgroundColor: "green" // Thumb (circle) color
            },
            "& .MuiSwitch-track": {
              backgroundColor: "white", // Track (background) color
              opacity: 1 // Ensure full color visibility
            },
            "& .Mui-checked .MuiSwitch-thumb": {
              backgroundColor: "green" // Thumb remains white when checked
            },
            "& .Mui-checked + .MuiSwitch-track": {
              backgroundColor: "white", // Track remains white when checked
              opacity: 2
            }
          }}
        />
      )
    },
    // {
    //   field: "walletAddress",
    //   headerName: "Wallet Address",
    //   type: "string",
    //   flex: 3,
    //   renderCell: (params) => {
    //     return (
    //       <div className="flex gap-1 items-center">
    //         <div>
    //           {params.value ? (
    //             <div className="flex gap-2 items-center" title={params.value}>
    //               {params.value.slice(0, 4) +
    //                 "..." +
    //                 params.value.slice(40, 42)}{" "}
    //               <span>
    //                 <CopyToClipboard text={params.value} onCopy={handleCopy}>
    //                   <button className="cursor-pointer">
    //                     {reactIcons.copy}
    //                   </button>
    //                 </CopyToClipboard>
    //               </span>
    //             </div>
    //           ) : (
    //             "-"
    //           )}
    //         </div>
    //       </div>
    //     );
    //   }
    // },
    {
      field: "createdAt",
      headerName: "CreatedAt",
      type: "string",
      flex: 3
    },
    {
      field: "status",
      headerName: "Status",
      type: "string",
      flex: 2,
      className: "bg-white px-8",
      valueFormatter: (params) => (params.value ? params.value : "-")
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   type: "string",
    //   flex: 2,
    //   renderCell: (params) => (
    //     <div
    //       className={`bg-white px-6  ${
    //         params.value === "Active" ? "text-green-600" : "text-gray-500"
    //       }`}
    //     >
    //       {params.value ? params.value : "-"}
    //     </div>
    //   )
    // },
    {
      field: "action",
      headerName: "Action",
      type: "actions",
      flex: 2,
      getActions: (params) => {
        return [<span key="eyeInvisible">{reactIcons.eyeInVisible}</span>];
      }
    }
  ];
  return (
    <>
      {isLoading && <Spinner />}
      <div>
        <div className="upper flex flex-col gap-4">
          <h4 className="flex items-center gap-2 text-24 mb-4 text-white">
            Genesis Stage
            {/* <FiAward className="text-[22px] text-yellow-dark" />{" "} */}
          </h4>
        </div>
        <div className=" py-4 pb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {metrics.map((metric, index) => (
              <div key={index} className="rounded border border-[#00D97A] p-4">
                <div className="text-16   font-medium text-white text-sm mb-1">
                  {metric.title}
                </div>
                <div className="text-white text-2xl font-bold">
                  {metric.value}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-between items-center">
          <h4 className=" text-24  text-white">Node Owner</h4>

          <div className="relative ">
            <input
              className="w-[250px] h-[45px] bg-transparent text-white"
              type="text"
              // value={searchText}
              placeholder="Search "
              // onChange={(e) => setSearchText(e.target.value)}
            />
            <span className="absolute  text-18 top-[calc(50%-9px)] right-2">
              {reactIcons.search}
            </span>
          </div>
        </div>
        <div className="h-[300px] bg-[#00341D] text-white w-full mt-4">
          <DataGrid
            loading={isLoading}
            rows={rows}
            getRowId={(row) => row._id} // Ensure _id is unique
            getEstimatedRowHeight={() => 52}
            columns={columns}
            initialState={{
              paginationModel: {
                pageSize: 8
              }
            }}
            rowCount={rowCountState} // Ensure this is updated with total row count
            pageSizeOptions={[8]}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={setPaginationModel}
            slots={{
              loadingOverlay: LinearProgress,
              noRowsOverlay: CustomNoRowsOverlay
            }}
            disableColumnMenu
            disableRowSelectionOnClick
            sx={{
              "& .MuiDataGrid-row:hover": {
                cursor: "default"
              }
            }}
          />
        </div>
      </div>
    </>
  );
};
export default DashboardLanding;
